// ligfrontend/src/components/Lig/MemberCard.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./MemberCard.css";
import { useAuth } from "../../context/AuthContext";

const MemberCard = ({ member, selectedYear, onDelete }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const getYearCount = () => {
    if (!selectedYear) return  0;
    return member.yearStats[selectedYear] || 0;
  };

  const handleCardClick = () => {
    if (user.email === member.email){
      navigate(`/mylig/${member.uname}`, {
        state: {
          selectedYear: selectedYear,
        },
      });
    }
  };

  return (
    <div className="member-card" onClick={handleCardClick}>
      <div className="member-card-header">
        <div className="avatar-container">
          <img
            src={member.avatar || "/images/mystery.png"}
            alt={member.name}
            className="avatar"
          />
        </div>
      </div>

      <div className="member-card-body">
        <h3 className="member-name">{member.name}</h3>

        {member.isFamilyHead && (
          <span className="family-head-badge">Family Head</span>
        )}

        <div className="member-stats">
          <div className="stat">
            <span className="stat-label">
              {selectedYear ? `${selectedYear} Posts` : "Total Posts"}
            </span>
            <span className="stat-value">{getYearCount()}</span>
          </div>
        </div>

        {member.lastPostDate && (
          <div className="last-post">
            <small>
              Last post: {new Date(member.lastPostDate).toLocaleDateString()}
            </small>
          </div>
        )}
      </div>

      {member.familyHead === user.email && (
        <div className="member-card-actions">
          <button
            className="btn-delete"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            Remove
          </button>
        </div>
      )}
    </div>
  );
};

export default MemberCard;
